<div rds-dialog-header>
  <h2 rds-dialog-title>{{ POPUPS.RELEASE_NOTE.TITLE }}</h2>
</div>
<div rds-dialog-content [formGroup]="form" class="dialog-form">
  <rds-form-field labelPosition="top">
    <rds-control-label>{{
      POPUPS.RELEASE_NOTE.NAME_LABEL
    }}</rds-control-label>
    <input rdsInput formControlName="header" />
    @if (form.controls.header.touched && form.controls.header.errors) {
      <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
    }
  </rds-form-field>
  <rds-form-field labelPosition="top">
    <rds-control-label>{{
      POPUPS.RELEASE_NOTE.HEADER_LABEL
    }}</rds-control-label>
    <input rdsInput formControlName="subheader" />
    @if (form.controls.subheader.touched && form.controls.subheader.errors) {
      <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
    }
  </rds-form-field>
  <div class="dialog-description">
    <rds-control-label>{{
      POPUPS.RELEASE_NOTE.DESCRIPTION_LABEL
      }}
      <span class="rich-editor-field-asterisk"> * </span>
    </rds-control-label>
    <app-rich-text-editor formControlName="description" [placeholder]=""
      [readonly]="false" [minHeight]="400"
      [invalid]="form.controls.description.touched && form.controls.description.invalid">
    </app-rich-text-editor>
    @if (form.controls.description.touched && form.controls.description.invalid) {
    <div class="editor-error">
      <rds-icon namespace="outlined" icon="warning_circle"></rds-icon>
      <span>{{ ERRORS.EMPTY }}</span>
    </div>
    }
  </div>
  <rds-form-field labelPosition="top">
    <rds-control-label>{{
      POPUPS.RELEASE_NOTE.LINK_LABEL
      }}</rds-control-label>
    <input rdsInput formControlName="url" />
    @if (
      form.controls.url.touched && form.controls.url.hasError("invalidUrl")
    ) {
      <rds-control-error> {{ ERRORS.INVALID_FORMAT }} </rds-control-error>
    }
  </rds-form-field>
</div>
<div rds-dialog-actions-container>
  <button rds-secondary-button [rds-dialog-close]="false" size="m">
    {{ BUTTONS.CANCEL }}
  </button>
  <button
    rds-primary-button
    size="m"
    (click)="submit()"
    [disabled]="form.invalid"
  >
    {{ BUTTONS.ADD }}
  </button>
</div>
